//文字コードはutf-8

// ハンバーガーメニュー
export function navigation() {
  const $openBtn = $('.jsMenuOpen');
  const $closeBtn = $('.jsMenuClose');
  const $header = $('header');
  const $body = $('body');
  const $nav = $('.jsNavigation');
  const $navInner = $('.header__menu__inner');
  // Open and Close
  function openMenu() {
    $header.addClass('is-act');
    $body.addClass('is-lock');
    $nav.stop(true, true).fadeIn(300);
    setTimeout(function () {
      $nav.addClass('is-act');
    }, 200);
  }

  function closeMenu() {
    $header.removeClass('is-act');
    $body.removeClass('is-lock');
    $nav.stop(true, true).fadeOut(300, function() {
      $nav.removeClass('is-act');
    });
  }
  function clickOutsideClose(e) {
    if (!$(e.target).closest($navInner).length) {
      closeMenu();
    }
  }

  // setup
  function setupHamburger() {
    $openBtn.on('click', openMenu);
    $closeBtn.on('click', closeMenu);
    $nav.on('click', clickOutsideClose);
  }

  setupHamburger();
}
